import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Target, DollarSign, BarChartHorizontal, Rocket, BarChart, Users } from "lucide-react";

export const WhyChooseUs = () => {
  const features = [
    {
      icon: <Users className="w-8 h-8 text-indigo-600" />,
      title: "Dedicated AI Agents",
      description: "Our AI Agents are deployed based on your industry requirements that help you stay ahead of industry trends and platform updates to maximize your campaign success",
      color: "indigo"
    },
    {
      icon: <Rocket className="w-8 h-8 text-blue-600" />,
      title: "Rapid Market Entry",
      description: "Get immediate visibility in your target market with strategically crafted PPC campaigns that deliver instant traffic and leads.",
      color: "blue"
    },
    {
      icon: <DollarSign className="w-8 h-8 text-purple-600" />,
      title: "ROI-Focused Campaigns",
      description: "Maximize your advertising budget with data-driven strategies that focus on delivering measurable results and positive return on investment.",
      color: "purple"
    },
    {
      icon: <Target className="w-8 h-8 text-blue-600" />,
      title: "Precision Targeting",
      description: "Leverage advanced audience segmentation and targeting capabilities to reach your ideal customers at the perfect moment in their buying journey.",
      color: "blue"
    },
    {
      icon: <BarChartHorizontal className="w-8 h-8 text-indigo-600" />,
      title: "Real-Time Optimization",
      description: "Continuous monitoring and optimization of your campaigns using AI-powered tools to ensure peak performance and cost efficiency.",
      color: "indigo"
    },
    {
      icon: <BarChart className="w-8 h-8 text-purple-600" />,
      title: "Advanced Analytics",
      description: "Comprehensive reporting and analytics that provide deep insights into campaign performance, user behavior, and conversion patterns.",
      color: "purple"
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center text-gray-900">
          Why Choose Our PPC Services?
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className={`h-full bg-white hover:shadow-xl transition-shadow duration-300`}>
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className={`w-16 h-16 rounded-full bg-${feature.color}-100 flex items-center justify-center mb-4`}>
                    {feature.icon}
                  </div>
                  <h3 className={`text-xl font-semibold mb-4 text-${feature.color}-900`}>
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};